/** A stable, human reference from an explicit one, else derived from the id. */
export const orderReference = (order: Record<string, unknown>, prefix = 'CHW-'): string => {
  const explicit = String(order.reference ?? '').trim()
  if (explicit) return explicit
  const id = String(order.id ?? '')
  return id ? `${prefix}${id.replace(/[^a-zA-Z0-9]/g, '').slice(0, 6).toUpperCase()}` : 'Order'
}

